import React, {useEffect, useState} from 'react';
import { UserContainer } from './style';
import axios from 'axios';
import AuthService from '../../../AuthService';
import { PaginationButton, PaginationContainer } from '../../Categories/style';
import { MdShoppingBag, MdAccessTime, MdLocalShipping, MdCancel } from 'react-icons/md';
import { FaUser, FaCalendarAlt, FaShoppingCart, FaBoxes, FaChevronLeft, FaChevronRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import Select from 'react-select';
import { Input } from '../../Login/style';

export default function Orders() {

    const [orders, setOrders] = useState([]);
    const [ordersStatistics, setOrdersStatistics] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(50);
    const [filters, setFilters] = useState({
        search: '',
        status: '',
        startDate: '',
        endDate: ''
    });

    const fetchOrders = async (page = 1, appliedFilters = filters) => {
        setLoading(true);
        try {
            const queryParams = new URLSearchParams();
            queryParams.append('page', page);
            queryParams.append('limit', limit);

            if (appliedFilters.search) queryParams.append('search', appliedFilters.search);
            if (appliedFilters.status) queryParams.append('status', appliedFilters.status);
            if (appliedFilters.startDate) queryParams.append('startDate', appliedFilters.startDate);
            if (appliedFilters.endDate) queryParams.append('endDate', appliedFilters.endDate);

            const response = await axios.get(`https://api.rb.beeapp.es/admin/orders?${queryParams.toString()}`, {
                headers: {
                    'Authorization': 'Bearer ' + AuthService.getToken()
                }
            });

            const data = response.data;
            setOrders(data.results || []);
            setPagination(data.pagination || {});
            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching orders:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders(1);

        axios.get('https://api.rb.beeapp.es/admin/orders/statistics/status', {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        }).then(response => {
            setOrdersStatistics(response.data);
        })
        .catch(error => {
            console.error(error);
        });
    }, []);

    const handleFilterChange = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: value }));
    };

    const applyFilters = () => {
        fetchOrders(1, filters);
    };

    const statusOptions = [
        { value: '', label: 'Todos los estados' },
        { value: 'Created', label: 'Pendiente' },
        { value: 'Preparing', label: 'Preparando' },
        { value: 'Shipped', label: 'Enviado' },
        { value: 'Delivered', label: 'Entregado' },
        { value: 'Cancelled', label: 'Cancelado' }
    ];

    const getStatusBadge = (status) => {
        const statusConfig = {
            'Created': { label: 'Pendiente', bg: '#fef3c7', color: '#92400e' },
            'Preparing': { label: 'Preparando', bg: '#dbeafe', color: '#1e40af' },
            'Shipped': { label: 'Enviado', bg: '#d1fae5', color: '#065f46' },
            'Delivered': { label: 'Entregado', bg: '#d1fae5', color: '#065f46' },
            'Cancelled': { label: 'Cancelado', bg: '#fee2e2', color: '#991b1b' }
        };

        const config = statusConfig[status] || statusConfig['Created'];

        return (
            <span style={{
                backgroundColor: config.bg,
                color: config.color,
                padding: '6px 14px',
                borderRadius: '12px',
                fontSize: '0.875rem',
                fontWeight: '500'
            }}>
                {config.label}
            </span>
        );
    };

    const formatOrderDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pagination.totalPages) {
            fetchOrders(page, filters);
        }
    };

    const handleLimitChange = (newLimit) => {
        setLimit(newLimit);
        fetchOrders(1, filters);
    };

    const renderPagination = () => {
        if (!pagination.totalPages || pagination.totalPages <= 1) return null;

        const pages = [];
        const maxVisible = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let endPage = Math.min(pagination.totalPages, startPage + maxVisible - 1);

        if (endPage - startPage + 1 < maxVisible) {
            startPage = Math.max(1, endPage - maxVisible + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return (
            <div style={{
                marginTop: '32px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                alignItems: 'center'
            }}>
                {/* Controles de paginación */}
                <PaginationContainer>
                    <PaginationButton
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1}
                        style={{
                            backgroundColor: '#fff',
                            border: '1px solid #e5e7eb',
                            color: currentPage === 1 ? '#d1d5db' : '#1f2937',
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                        }}
                    >
                        <FaAngleDoubleLeft />
                    </PaginationButton>

                    <PaginationButton
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                            backgroundColor: '#fff',
                            border: '1px solid #e5e7eb',
                            color: currentPage === 1 ? '#d1d5db' : '#1f2937',
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                        }}
                    >
                        <FaChevronLeft />
                    </PaginationButton>

                    {pages.map(page => (
                        <PaginationButton
                            key={page}
                            onClick={() => handlePageChange(page)}
                            style={{
                                backgroundColor: page === currentPage ? '#028322' : '#fff',
                                border: '1px solid #e5e7eb',
                                color: page === currentPage ? '#fff' : '#1f2937',
                                fontWeight: page === currentPage ? '600' : '400'
                            }}
                        >
                            {page}
                        </PaginationButton>
                    ))}

                    <PaginationButton
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === pagination.totalPages}
                        style={{
                            backgroundColor: '#fff',
                            border: '1px solid #e5e7eb',
                            color: currentPage === pagination.totalPages ? '#d1d5db' : '#1f2937',
                            cursor: currentPage === pagination.totalPages ? 'not-allowed' : 'pointer'
                        }}
                    >
                        <FaChevronRight />
                    </PaginationButton>

                    <PaginationButton
                        onClick={() => handlePageChange(pagination.totalPages)}
                        disabled={currentPage === pagination.totalPages}
                        style={{
                            backgroundColor: '#fff',
                            border: '1px solid #e5e7eb',
                            color: currentPage === pagination.totalPages ? '#d1d5db' : '#1f2937',
                            cursor: currentPage === pagination.totalPages ? 'not-allowed' : 'pointer'
                        }}
                    >
                        <FaAngleDoubleRight />
                    </PaginationButton>
                </PaginationContainer>

                {/* Selector de items por página */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    fontSize: '0.875rem',
                    color: '#6b7280'
                }}>
                    <span>Por página:</span>
                    <select
                        value={limit}
                        onChange={(e) => handleLimitChange(Number(e.target.value))}
                        style={{
                            padding: '6px 32px 6px 12px',
                            border: '1px solid #e5e7eb',
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            color: '#1f2937',
                            fontSize: '0.875rem',
                            cursor: 'pointer'
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
            </div>
        );
    };

    return (
        <UserContainer>
            {/* Header simple */}
            <div style={{ marginBottom: '32px' }}>
                <h1 style={{
                    color: '#028322',
                    fontSize: '2rem',
                    marginBottom: '8px',
                    fontWeight: '600',
                    margin: 0
                }}>
                    Gestión de Pedidos
                </h1>
                <p style={{
                    fontSize: '1rem',
                    color: '#6b7280',
                    margin: '8px 0 0 0'
                }}>
                    Administra y supervisa todos los pedidos de la plataforma
                </p>
            </div>

            {/* Cards con bordes de colores */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '16px',
                marginBottom: '32px'
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #028322',
                    borderRadius: '12px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280', marginBottom: '4px' }}>
                            Total Pedidos
                        </p>
                        <p style={{ margin: 0, fontSize: '2rem', fontWeight: '700', color: '#1f2937' }}>
                            {ordersStatistics?.Total || 0}
                        </p>
                    </div>
                    <MdShoppingBag size={40} color="#028322" />
                </div>

                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #f59e0b',
                    borderRadius: '12px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280', marginBottom: '4px' }}>
                            Pendientes
                        </p>
                        <p style={{ margin: 0, fontSize: '2rem', fontWeight: '700', color: '#1f2937' }}>
                            {ordersStatistics?.Created || 0}
                        </p>
                    </div>
                    <MdAccessTime size={40} color="#f59e0b" />
                </div>

                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #3b82f6',
                    borderRadius: '12px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280', marginBottom: '4px' }}>
                            Enviados
                        </p>
                        <p style={{ margin: 0, fontSize: '2rem', fontWeight: '700', color: '#1f2937' }}>
                            {(ordersStatistics?.Shipped || 0) + (ordersStatistics?.Delivered || 0)}
                        </p>
                    </div>
                    <MdLocalShipping size={40} color="#3b82f6" />
                </div>

                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #ef4444',
                    borderRadius: '12px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280', marginBottom: '4px' }}>
                            Cancelados
                        </p>
                        <p style={{ margin: 0, fontSize: '2rem', fontWeight: '700', color: '#1f2937' }}>
                            {ordersStatistics?.Cancelled || 0}
                        </p>
                    </div>
                    <MdCancel size={40} color="#ef4444" />
                </div>
            </div>

            {/* Filtros */}
            <div style={{
                backgroundColor: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                padding: '20px',
                marginBottom: '24px',
                display: 'flex',
                gap: '12px',
                flexWrap: 'wrap',
                alignItems: 'center'
            }}>
                <Input
                    type="text"
                    placeholder="Buscar por cliente o ID..."
                    value={filters.search}
                    onChange={(e) => handleFilterChange('search', e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && applyFilters()}
                    style={{
                        flex: '1',
                        minWidth: '200px',
                        padding: '10px 16px',
                        fontSize: '0.875rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px'
                    }}
                />

                <div style={{ minWidth: '200px' }}>
                    <Select
                        options={statusOptions}
                        value={statusOptions.find(o => o.value === filters.status)}
                        onChange={(option) => {
                            handleFilterChange('status', option.value);
                            fetchOrders(1, { ...filters, status: option.value });
                        }}
                        placeholder="Todos los estados"
                    />
                </div>

                <Input
                    type="date"
                    value={filters.startDate}
                    onChange={(e) => handleFilterChange('startDate', e.target.value)}
                    style={{
                        padding: '10px 16px',
                        fontSize: '0.875rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        minWidth: '150px'
                    }}
                />

                <Input
                    type="date"
                    value={filters.endDate}
                    onChange={(e) => handleFilterChange('endDate', e.target.value)}
                    style={{
                        padding: '10px 16px',
                        fontSize: '0.875rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        minWidth: '150px'
                    }}
                />

                <button
                    onClick={applyFilters}
                    style={{
                        backgroundColor: '#028322',
                        color: 'white',
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        cursor: 'pointer'
                    }}
                >
                    Filtrar
                </button>
            </div>

            {/* Información de registros */}
            {pagination.totalOrders && (
                <div style={{
                    fontSize: '0.875rem',
                    color: '#6b7280',
                    marginBottom: '16px'
                }}>
                    Mostrando {((currentPage - 1) * limit) + 1} - {Math.min(currentPage * limit, pagination.totalOrders)} de {pagination.totalOrders} pedidos
                </div>
            )}

            {/* Lista de pedidos */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {!loading && orders.length > 0 && orders.map((order) => {
                    const isBarOffice = order.sourceApp === 'BarOffice';

                    return (
                        <div
                            key={order._id}
                            onClick={() => window.location.href = `/admin/order/${order._id}`}
                            style={{
                                backgroundColor: '#fff',
                                border: '1px solid #e5e7eb',
                                borderRadius: '12px',
                                padding: '20px',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f9fafb';
                                e.currentTarget.style.borderColor = '#028322';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#fff';
                                e.currentTarget.style.borderColor = '#e5e7eb';
                            }}
                        >
                            {/* Header: Avatar, Nombre y Badges */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '16px'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        borderRadius: '50%',
                                        backgroundColor: isBarOffice ? '#dbeafe' : '#d1fae5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <FaUser size={20} color={isBarOffice ? '#3b82f6' : '#10b981'} />
                                    </div>

                                    <div>
                                        <h3 style={{
                                            margin: 0,
                                            fontSize: '1rem',
                                            fontWeight: '600',
                                            color: '#1f2937',
                                            marginBottom: '2px'
                                        }}>
                                            {order.UserID?.Name} {order.UserID?.Surname}
                                        </h3>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '0.875rem',
                                            color: '#9ca3af'
                                        }}>
                                            #{order._id.slice(-8)}
                                        </p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    {getStatusBadge(order.Status)}
                                    {isBarOffice && (
                                        <span style={{
                                            backgroundColor: '#dbeafe',
                                            color: '#1e40af',
                                            padding: '6px 14px',
                                            borderRadius: '12px',
                                            fontSize: '0.875rem',
                                            fontWeight: '500',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}>
                                            <MdShoppingBag size={14} />
                                            BarOffice
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* Información del pedido */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '32px'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <FaCalendarAlt size={16} color="#9ca3af" />
                                    <div>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '0.75rem',
                                            color: '#9ca3af',
                                            textTransform: 'uppercase',
                                            marginBottom: '2px'
                                        }}>
                                            Fecha
                                        </p>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '0.875rem',
                                            color: '#1f2937'
                                        }}>
                                            {formatOrderDate(order.CreationDate)}
                                        </p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{ fontSize: '1rem', color: '#9ca3af' }}>$</span>
                                    <div>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '0.75rem',
                                            color: '#9ca3af',
                                            textTransform: 'uppercase',
                                            marginBottom: '2px'
                                        }}>
                                            Total
                                        </p>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '0.875rem',
                                            color: '#028322',
                                            fontWeight: '600'
                                        }}>
                                            {order.TotalAmount.toFixed(2).replace('.', ',')}€
                                        </p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <FaBoxes size={16} color="#9ca3af" />
                                    <div>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '0.75rem',
                                            color: '#9ca3af',
                                            textTransform: 'uppercase',
                                            marginBottom: '2px'
                                        }}>
                                            Productos
                                        </p>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '0.875rem',
                                            color: '#1f2937'
                                        }}>
                                            {order.Products?.length || 0} artículo{order.Products?.length !== 1 ? 's' : ''}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Sin resultados */}
            {!loading && orders.length === 0 && (
                <div style={{
                    textAlign: 'center',
                    padding: '60px',
                    backgroundColor: '#f9fafb',
                    borderRadius: '12px',
                    border: '2px dashed #e5e7eb'
                }}>
                    <MdShoppingBag size={64} color="#d1d5db" style={{ marginBottom: '16px' }} />
                    <p style={{ color: '#6b7280', margin: 0 }}>No se encontraron pedidos</p>
                </div>
            )}

            {/* Loading */}
            {loading && (
                <div style={{
                    textAlign: 'center',
                    padding: '40px'
                }}>
                    <p style={{ color: '#6b7280' }}>Cargando pedidos...</p>
                </div>
            )}

            {/* Paginación */}
            {renderPagination()}
        </UserContainer>
    );
}
